export default __webpack_public_path__ + "static/krystel@2x-ea7eb3100aaac0fc6a44f2b847f91297.jpg";